// import styles from "./home.module.css";
import Timeline from "../../components/Timeline/Timeline";
import Q from "../../components/questionSubmission/qs";
import TestimonialCarousel from "../../components/reviews/reviews";
import Homecompo from "../../components/home/home";
import Location from "../../components/location/location";
import SpeakersSection from "../../components/Speakers/SpeakersSection";
const Home = () => {
    return (
        <div>
            <Homecompo></Homecompo>
            <SpeakersSection></SpeakersSection>
            <Q />
            <Timeline></Timeline>
            <TestimonialCarousel />
            <Location></Location>
        </div>
    );
}
 
export default Home;